import {
    MobileAppsListAction,
    UPDATE_APPS_DATA
} from '../actions/mobile-apps-list';
import { MobileAppsListState, State } from '../typings/state';

export const AppsListInitialState: MobileAppsListState = {
    gridData: {
        total: 100,
        data: [],
        allItemsIds: []
    }
};

export function mobileAppsList(
    state: MobileAppsListState = AppsListInitialState,
    action: MobileAppsListAction,
    fullState: State
): MobileAppsListState {
    switch (action.type) {
        case UPDATE_APPS_DATA:
            return {
                ...state,
                gridData: action.gridData
            };
        default:
            return state;
    }
}
